import { Swiper, SwiperSlide } from "swiper/react";
import { Grid } from "swiper";
import "swiper/css";
import "swiper/css/grid";

import Text from "../../components/Text";
import coachImage from "./../../assets/images/coach-1.png";
import CoachCard from "../../components/CoachCard";
import ShowAllLink from "../../components/ShowAllLink";

const CoachesSection = () => {
  return (
    <section className="flex justify-center">
      <div className="xs:w-full lg:w-9/12 xl:w-8/12">
        <div className="heading px-4">
          <Text
            text={"Verified Virtual Nutrition Coaches"}
            component="h3"
            classes={"text-xl font-semibold"}
          />
        </div>
        <div className="coaches-list">
          <Swiper
            modules={[Grid]}
            breakpoints={{
              1200: {
                slidesPerView: 4,
                grid: {
                  rows: 2,
                  fill: "row",
                },
              },
              768: {
                slidesPerView: 3,
                grid: {
                  rows: 1,
                },
              },
              560: {
                slidesPerView: 2.5,
                grid: {
                  rows: 1,
                },
              },
              360: {
                slidesPerView: 1.5,
                grid: {
                  rows: 1,
                },
              },
              320: {
                slidesPerView: 1,
                grid: {
                  fill: "row",
                  rows: 1,
                },
              },
            }}
          >
            {Array(8)
              .fill(true)
              .map((slide, index) => {
                return (
                  <SwiperSlide className="flex justify-center px-4" key={index}>
                    <CoachCard coachImage={coachImage} />
                  </SwiperSlide>
                );
              })}
          </Swiper>
        </div>
        <div className="px-4 text-[15px] font-medium">
          <ShowAllLink text={"Show All(100+)"} to="/" />
        </div>
      </div>
    </section>
  );
};

export default CoachesSection;
